import React, { memo } from 'react';
import { useStoreState, Position } from 'react-flow-renderer';
import {
  ConditionalEndStyle,
  ConditionalEndStyleInside,
  HandleStyle,
} from './styles';

const ConditionalEnd = ({
  data,
  targetPosition = Position.Left,
  sourcePosition = Position.Right,
  selected,
  id,
}) => {
  return (
    <ConditionalEndStyle
      criticalPath={data.criticalPath}
      status={data.status}
      selected={selected}
      className="flow_elements_node"
      data-id={id}
    >
      <ConditionalEndStyleInside selected={selected} />
      <HandleStyle
        type="target"
        id="c"
        position={targetPosition}
        selected={selected}
        style={{ top: 0 }}
      />
      <HandleStyle
        type="source"
        position={sourcePosition}
        id="a"
        selected={selected}
        style={{
          top: '100%',
        }}
      />
    </ConditionalEndStyle>
  );
};

export default memo(ConditionalEnd);
